import React from "react";

// Perrito sentado triste
export const SadSittingDog = () => (
  <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" width="280" height="280">
    {/* Cuerpo */}
    <ellipse cx="150" cy="210" rx="65" ry="55" fill="#C8A882" />
    {/* Patas delanteras */}
    <ellipse cx="115" cy="255" rx="18" ry="22" fill="#C8A882" />
    <ellipse cx="185" cy="255" rx="18" ry="22" fill="#C8A882" />
    <ellipse cx="115" cy="270" rx="16" ry="10" fill="#A08060" />
    <ellipse cx="185" cy="270" rx="16" ry="10" fill="#A08060" />
    {/* Cabeza */}
    <circle cx="150" cy="130" r="55" fill="#D4B896" />
    {/* Orejas caídas */}
    <ellipse cx="100" cy="110" rx="22" ry="40" fill="#A08060" transform="rotate(-15, 100, 110)" />
    <ellipse cx="200" cy="110" rx="22" ry="40" fill="#A08060" transform="rotate(15, 200, 110)" />
    {/* Ojos tristes */}
    <ellipse cx="132" cy="125" rx="10" ry="12" fill="white" />
    <ellipse cx="168" cy="125" rx="10" ry="12" fill="white" />
    <circle cx="134" cy="128" r="6" fill="#333" />
    <circle cx="170" cy="128" r="6" fill="#333" />
    <circle cx="136" cy="126" r="2.5" fill="white" />
    <circle cx="172" cy="126" r="2.5" fill="white" />
    {/* Cejas tristes */}
    <line x1="122" y1="110" x2="140" y2="114" stroke="#6B5B4A" strokeWidth="3" strokeLinecap="round" />
    <line x1="178" y1="110" x2="160" y2="114" stroke="#6B5B4A" strokeWidth="3" strokeLinecap="round" />
    {/* Nariz */}
    <ellipse cx="150" cy="145" rx="10" ry="7" fill="#333" />
    {/* Boca triste */}
    <path d="M138 155 Q150 148 162 155" stroke="#6B5B4A" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    {/* Cola */}
    <path d="M215 200 Q240 175 235 155" stroke="#A08060" strokeWidth="10" fill="none" strokeLinecap="round" />
    {/* Mancha en el ojo */}
    <ellipse cx="168" cy="122" rx="18" ry="16" fill="#A08060" opacity="0.4" />
    {/* Collar */}
    <path d="M110 165 Q150 180 190 165" stroke="#ea0000" strokeWidth="5" fill="none" strokeLinecap="round" />
    <circle cx="150" cy="175" r="5" fill="#FFD700" />
  </svg>
);

// Perrito acostado con ojos de cachorrito
export const LyingPuppyDog = () => (
  <svg viewBox="0 0 300 260" xmlns="http://www.w3.org/2000/svg" width="300" height="260">
    {/* Cuerpo acostado */}
    <ellipse cx="160" cy="180" rx="90" ry="40" fill="#E8D5B7" />
    {/* Patas estiradas */}
    <ellipse cx="80" cy="210" rx="25" ry="12" fill="#E8D5B7" />
    <ellipse cx="240" cy="210" rx="25" ry="12" fill="#E8D5B7" />
    <ellipse cx="80" cy="215" rx="18" ry="8" fill="#C8A882" />
    <ellipse cx="240" cy="215" rx="18" ry="8" fill="#C8A882" />
    {/* Cabeza apoyada en patas */}
    <circle cx="130" cy="140" r="50" fill="#F0E0C8" />
    {/* Orejas grandes caídas */}
    <ellipse cx="82" cy="120" rx="25" ry="45" fill="#C8A882" transform="rotate(-20, 82, 120)" />
    <ellipse cx="178" cy="115" rx="22" ry="40" fill="#C8A882" transform="rotate(10, 178, 115)" />
    {/* Ojos grandes de cachorrito */}
    <ellipse cx="112" cy="132" rx="14" ry="16" fill="white" />
    <ellipse cx="148" cy="132" rx="14" ry="16" fill="white" />
    <circle cx="114" cy="136" r="9" fill="#5B3A1A" />
    <circle cx="150" cy="136" r="9" fill="#5B3A1A" />
    <circle cx="117" cy="133" r="4" fill="white" />
    <circle cx="153" cy="133" r="4" fill="white" />
    <circle cx="111" cy="130" r="2" fill="white" />
    <circle cx="147" cy="130" r="2" fill="white" />
    {/* Cejas preocupadas */}
    <path d="M98 118 Q110 114 124 120" stroke="#8B7355" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <path d="M136 120 Q148 114 162 118" stroke="#8B7355" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    {/* Nariz */}
    <ellipse cx="130" cy="152" rx="9" ry="6" fill="#333" />
    <ellipse cx="130" cy="150" rx="4" ry="2" fill="#555" opacity="0.5" />
    {/* Boca */}
    <path d="M122 160 Q130 156 138 160" stroke="#8B7355" strokeWidth="2" fill="none" strokeLinecap="round" />
    {/* Cola enrollada */}
    <path d="M248 170 Q270 150 265 130 Q260 115 248 125" stroke="#C8A882" strokeWidth="9" fill="none" strokeLinecap="round" />
    {/* Collar */}
    <path d="M90 160 Q130 175 170 160" stroke="#ea0000" strokeWidth="4" fill="none" strokeLinecap="round" />
    <circle cx="130" cy="170" r="4" fill="#FFD700" />
  </svg>
);

// Perrito con cabeza ladeada confundido
export const ConfusedDog = () => (
  <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" width="280" height="280">
    {/* Cuerpo */}
    <ellipse cx="150" cy="220" rx="60" ry="50" fill="#F5E6D0" />
    {/* Patas */}
    <rect x="108" y="248" rx="10" ry="10" width="25" height="30" fill="#F5E6D0" />
    <rect x="168" y="248" rx="10" ry="10" width="25" height="30" fill="#F5E6D0" />
    <ellipse cx="120" cy="275" rx="15" ry="8" fill="#D4B896" />
    <ellipse cx="180" cy="275" rx="15" ry="8" fill="#D4B896" />
    {/* Cabeza ladeada */}
    <circle cx="150" cy="130" r="52" fill="#F5E6D0" transform="rotate(-15, 150, 130)" />
    {/* Orejas - una arriba, una caída */}
    <ellipse cx="108" cy="82" rx="18" ry="32" fill="#D4B896" transform="rotate(-25, 108, 82)" />
    <ellipse cx="198" cy="105" rx="20" ry="35" fill="#D4B896" transform="rotate(25, 198, 105)" />
    {/* Manchas */}
    <circle cx="170" cy="120" r="25" fill="#C8A882" opacity="0.5" />
    {/* Ojos confundidos */}
    <ellipse cx="132" cy="122" rx="11" ry="13" fill="white" />
    <ellipse cx="168" cy="118" rx="11" ry="13" fill="white" />
    <circle cx="134" cy="124" r="7" fill="#333" />
    <circle cx="170" cy="120" r="7" fill="#333" />
    <circle cx="136" cy="122" r="3" fill="white" />
    <circle cx="172" cy="118" r="3" fill="white" />
    {/* Ceja levantada (confusión) */}
    <path d="M122 105 Q132 100 142 108" stroke="#8B7355" strokeWidth="3" fill="none" strokeLinecap="round" />
    <line x1="158" y1="100" x2="178" y2="105" stroke="#8B7355" strokeWidth="3" strokeLinecap="round" />
    {/* Nariz */}
    <ellipse cx="150" cy="140" rx="9" ry="7" fill="#333" />
    {/* Boca abierta */}
    <path d="M140 152 Q150 160 160 152" stroke="#8B7355" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <ellipse cx="150" cy="158" rx="8" ry="5" fill="#E88B8B" opacity="0.6" />
    {/* Signo de interrogación */}
    <text x="210" y="80" fontSize="40" fill="#ea0000" fontWeight="bold" opacity="0.7">?</text>
    {/* Cola */}
    <path d="M210 210 Q235 190 230 165" stroke="#D4B896" strokeWidth="9" fill="none" strokeLinecap="round" />
    {/* Collar */}
    <path d="M108 160 Q150 175 192 158" stroke="#ea0000" strokeWidth="4.5" fill="none" strokeLinecap="round" />
    <circle cx="150" cy="170" r="4.5" fill="#FFD700" />
  </svg>
);

// Perrito llorando con charco de lágrimas
export const CryingDog = () => (
  <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" width="280" height="280">
    {/* Cuerpo */}
    <ellipse cx="150" cy="215" rx="58" ry="50" fill="#D2B48C" />
    {/* Patas */}
    <ellipse cx="118" cy="258" rx="16" ry="20" fill="#D2B48C" />
    <ellipse cx="182" cy="258" rx="16" ry="20" fill="#D2B48C" />
    <ellipse cx="118" cy="272" rx="14" ry="8" fill="#B8956A" />
    <ellipse cx="182" cy="272" rx="14" ry="8" fill="#B8956A" />
    {/* Cabeza */}
    <circle cx="150" cy="128" r="52" fill="#E0C8A0" />
    {/* Orejas super caídas */}
    <ellipse cx="95" cy="125" rx="20" ry="45" fill="#B8956A" transform="rotate(-10, 95, 125)" />
    <ellipse cx="205" cy="125" rx="20" ry="45" fill="#B8956A" transform="rotate(10, 205, 125)" />
    {/* Ojos cerrados llorando */}
    <path d="M125 122 Q135 130 145 122" stroke="#5B3A1A" strokeWidth="3" fill="none" strokeLinecap="round" />
    <path d="M155 122 Q165 130 175 122" stroke="#5B3A1A" strokeWidth="3" fill="none" strokeLinecap="round" />
    {/* Lágrimas */}
    <path d="M128 130 Q126 145 130 155" stroke="#6CB4EE" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.7" />
    <path d="M172 130 Q174 145 170 155" stroke="#6CB4EE" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.7" />
    <ellipse cx="130" cy="158" rx="4" ry="5" fill="#6CB4EE" opacity="0.5" />
    <ellipse cx="170" cy="158" rx="4" ry="5" fill="#6CB4EE" opacity="0.5" />
    {/* Gotitas cayendo */}
    <ellipse cx="125" cy="168" rx="2.5" ry="3.5" fill="#6CB4EE" opacity="0.4" />
    <ellipse cx="175" cy="165" rx="2.5" ry="3.5" fill="#6CB4EE" opacity="0.4" />
    {/* Cejas muy tristes */}
    <line x1="118" y1="108" x2="142" y2="115" stroke="#5B3A1A" strokeWidth="3" strokeLinecap="round" />
    <line x1="182" y1="108" x2="158" y2="115" stroke="#5B3A1A" strokeWidth="3" strokeLinecap="round" />
    {/* Nariz */}
    <ellipse cx="150" cy="140" rx="9" ry="6.5" fill="#333" />
    {/* Boca temblando */}
    <path d="M135 152 Q140 158 145 154 Q150 150 155 154 Q160 158 165 152" stroke="#8B7355" strokeWidth="2" fill="none" strokeLinecap="round" />
    {/* Cola caída */}
    <path d="M208 210 Q225 215 228 230" stroke="#B8956A" strokeWidth="8" fill="none" strokeLinecap="round" />
    {/* Collar */}
    <path d="M108 158 Q150 172 192 158" stroke="#ea0000" strokeWidth="4.5" fill="none" strokeLinecap="round" />
    <circle cx="150" cy="168" r="4.5" fill="#FFD700" />
  </svg>
);

// Perrito con pata levantada pidiendo perdón
export const SorryDog = () => (
  <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" width="280" height="280">
    {/* Cuerpo */}
    <ellipse cx="155" cy="215" rx="62" ry="48" fill="#C4A57B" />
    {/* Pata trasera */}
    <ellipse cx="190" cy="255" rx="17" ry="22" fill="#C4A57B" />
    <ellipse cx="190" cy="272" rx="15" ry="8" fill="#A08060" />
    {/* Pata delantera derecha (en el suelo) */}
    <ellipse cx="140" cy="255" rx="15" ry="22" fill="#C4A57B" />
    <ellipse cx="140" cy="272" rx="13" ry="8" fill="#A08060" />
    {/* Pata delantera izquierda (levantada) */}
    <rect x="95" y="180" rx="10" ry="10" width="22" height="45" fill="#C4A57B" transform="rotate(-30, 106, 200)" />
    <ellipse cx="88" cy="185" rx="13" ry="10" fill="#A08060" transform="rotate(-30, 88, 185)" />
    {/* Cabeza */}
    <circle cx="150" cy="125" r="52" fill="#D9C4A0" />
    {/* Orejas */}
    <ellipse cx="100" cy="100" rx="20" ry="38" fill="#A08060" transform="rotate(-20, 100, 100)" />
    <ellipse cx="200" cy="100" rx="20" ry="38" fill="#A08060" transform="rotate(20, 200, 100)" />
    {/* Ojos grandes suplicantes */}
    <ellipse cx="132" cy="120" rx="14" ry="17" fill="white" />
    <ellipse cx="168" cy="120" rx="14" ry="17" fill="white" />
    <circle cx="135" cy="124" r="10" fill="#5B3A1A" />
    <circle cx="171" cy="124" r="10" fill="#5B3A1A" />
    <circle cx="138" cy="120" r="4.5" fill="white" />
    <circle cx="174" cy="120" r="4.5" fill="white" />
    <circle cx="132" cy="118" r="2" fill="white" />
    <circle cx="168" cy="118" r="2" fill="white" />
    {/* Cejas preocupadas */}
    <path d="M118 102 Q130 98 144 106" stroke="#6B5B4A" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <path d="M156 106 Q168 98 182 102" stroke="#6B5B4A" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    {/* Nariz */}
    <ellipse cx="150" cy="140" rx="9" ry="7" fill="#333" />
    {/* Boca - sonrisa nerviosa */}
    <path d="M140 152 Q150 158 160 152" stroke="#6B5B4A" strokeWidth="2" fill="none" strokeLinecap="round" />
    {/* Lengüita */}
    <ellipse cx="150" cy="160" rx="6" ry="8" fill="#E88B8B" />
    {/* Cola moviéndose */}
    <path d="M218 200 Q245 175 250 148" stroke="#A08060" strokeWidth="9" fill="none" strokeLinecap="round" />
    {/* Collar */}
    <path d="M108 155 Q150 170 192 155" stroke="#ea0000" strokeWidth="4.5" fill="none" strokeLinecap="round" />
    <circle cx="150" cy="165" r="4.5" fill="#FFD700" />
  </svg>
);

const DOG_COMPONENTS = [
  SadSittingDog,
  LyingPuppyDog,
  ConfusedDog,
  CryingDog,
  SorryDog,
];

export const getRandomDog = () => {
  const index = Math.floor(Math.random() * DOG_COMPONENTS.length);
  return DOG_COMPONENTS[index];
};

export default DOG_COMPONENTS;
